import { makeGetRequest } from 'owa-ows-gateway';
import { isFeatureEnabled } from 'owa-feature-flags';

const GETPREFERREDROOMLISTS_ENDPOINT_URL = isFeatureEnabled('cal-mf-placesb2')
    ? 'schedulingb2/api/v1.0/me/findtoplocalities(top=5)'
    : 'scheduling/api/v1.0/me/findtoplocalities(top=5)';

/**
 * Performs a request to the Scheduling API to fetch user's preferred roomlist
 */
export default function getPreferredRoomLists(): Promise<Response> {
    return makeGetRequest(GETPREFERREDROOMLISTS_ENDPOINT_URL, undefined, true, undefined);
}
